export default __webpack_public_path__ + "static/media/ScriptsImg.579876b3.jpg";